module.exports = __webpack_public_path__ + "img/5.bd998345.jpg";